var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15002_47316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9984 5.96603C14.9484 5.95769 14.8901 5.95769 14.8401 5.96603C13.6901 5.92436 12.7734 4.98269 12.7734 3.81603C12.7734 2.62436 13.7318 1.66602 14.9234 1.66602C16.1151 1.66602 17.0734 2.63269 17.0734 3.81603C17.0651 4.98269 16.1484 5.92436 14.9984 5.96603Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1383 12.0328C15.28 12.2245 16.5383 12.0245 17.4216 11.4328C18.5966 10.6495 18.5966 9.36615 17.4216 8.58282C16.53 7.99115 15.2549 7.79114 14.1133 7.99114",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97344 5.96603C5.02344 5.95769 5.08177 5.95769 5.13177 5.96603C6.28177 5.92436 7.19844 4.98269 7.19844 3.81603C7.19844 2.62436 6.24011 1.66602 5.04844 1.66602C3.85677 1.66602 2.89844 2.63269 2.89844 3.81603C2.90677 4.98269 3.82344 5.92436 4.97344 5.96603Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83255 12.0328C4.69088 12.2245 3.43255 12.0245 2.54922 11.4328C1.37422 10.6495 1.37422 9.36615 2.54922 8.58282C3.44089 7.99115 4.71588 7.79114 5.85755 7.99114",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0023 12.1906C9.95234 12.1823 9.89401 12.1823 9.84401 12.1906C8.69401 12.1489 7.77734 11.2073 7.77734 10.0406C7.77734 8.84897 8.73568 7.89062 9.92734 7.89062C11.119 7.89062 12.0773 8.8573 12.0773 10.0406C12.069 11.2073 11.1523 12.1573 10.0023 12.1906Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57656 14.8168C6.40156 15.6001 6.40156 16.8835 7.57656 17.6668C8.9099 18.5585 11.0932 18.5585 12.4266 17.6668C13.6016 16.8835 13.6016 15.6001 12.4266 14.8168C11.1016 13.9335 8.9099 13.9335 7.57656 14.8168Z",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15002_47316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.485353c2c367715263ad94baedd7e34d.svg";
export { ForwardRef as ReactComponent };